const localeNames = {"en":"English","es":"Spanish","zh":"Chinese","fr":"French","ar":"Arabic"}

export default localeNames
